module.exports = __webpack_public_path__ + "static/img/1.3aed33f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/introduce/1.png
// module id = beIe
// module chunks = 0